module.exports = __webpack_public_path__ + "img/img1.8aedd81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/saasIntroduction/img1.png
// module id = ukFP
// module chunks = 171